// startup
// Load entry module and return exports
// This entry module depends on other loaded chunks and execution need to be delayed
let __webpack_exports__ = __webpack_require__.O(undefined, ["vendors-node_modules_vue-loader_dist_exportHelper_js-node_modules_bootstrap_dist_css_bootstra-d97b5a"], () => (__webpack_require__("./src/main.ts")))
__webpack_exports__ = __webpack_require__.O(__webpack_exports__);
